import { TaxonomyNodeSuggestionOption } from '@modules/common/components/TaxonomyNodesAutoComplete/types';
import { getDisplayNameForLabelType } from '@modules/common/utils';
import { TaxonomySearchGroup } from 'generated/graphql';

interface getGroupOptionsOptions {
  taxonomySearchGroups?: TaxonomySearchGroup[];
}

export function getTaxonomySearchGroupOptions({
  taxonomySearchGroups,
}: getGroupOptionsOptions) {
  const options: TaxonomyNodeSuggestionOption[] = [];
  const groupOrder: string[] = [];

  taxonomySearchGroups?.forEach((group) => {
    const groupDisplayName = getDisplayNameForLabelType(group.type) ?? '';

    group.options.forEach((option) => {
      options.push({
        ...option,
        groupID: group.type,
        groupDisplayName,
        groupType: group.type,
      });
    });

    if (group.hasMore) {
      options.push({
        id: `${group.type}_more`,
        displayName: 'More',
        groupID: group.type,
        groupDisplayName,
        groupType: group.type,
      });
    }

    groupOrder.push(group.type);
  });

  return { options, rows: [groupOrder] };
}
